import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {GlobalConstantsComponent} from '../shared/global-constants/global-constants.component';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentsSharedService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient,
  ) { }


  /**
   * Si un userId est fournit, on update le document de ce user ; sinon on update le document du user connecté
   * Vérifie le type de fichier avant de save
   *  Renvoi : {
   *    status : error || success
   *    file: inexistant si erreur || le document uploaded
   *    message: file || inexistant si success
   *    data : error msg || inexistant si success
   *  }
   *
   * @param document_type
   * @param file
   * @param mode
   * @param userId - optionnel
   */
  sendDocument(document_type, file, mode, userId?) {
    const uploadData = new FormData();
    uploadData.append(document_type, file, file.name);
    uploadData.append('mode', mode);

    const currentUser = this.authenticationService.currentUserValue;
    const httpOptions: object = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${currentUser.token}`
      }),
      reportProgress: true,
    }
    if (!userId) {
      const req = new HttpRequest('POST', `${this.apiUrl}user/sendDocument`, uploadData, httpOptions)
      return this.http.request(req);
    }
    const req = new HttpRequest('POST', `${this.apiUrl}user/` + userId + `/sendDocument`, uploadData, httpOptions)
    return this.http.request(req);
  }

  /**
   * Supprime le document s'il existe
   * Renvoi : {
   *   status : error || success
   * }
   * @param documentID
   */
  deleteDocument(documentID) {
    return this.http.delete(`${this.apiUrl}user/deleteDocument/` + documentID);
  }

  /**
   * Génère un PDF pour l'utilisateur, le sauvegarde en base
   * renvoi un objet PDF ou 404 si erreur
   * @param key
   * @param userId
   */
  genPdf(key, userId ?): Observable<Blob>{
    if (!userId) {
      return this.http.get<Blob>(`${this.apiUrl}user/genDoc/`+ key +`.pdf`, { responseType :
          'blob' as 'json'}) as any;
    }
    return this.http.get<Blob>(`${this.apiUrl}user/`+ userId +`/genDoc/`+ key +`.pdf`, { responseType :
        'blob' as 'json'}) as any;
  }

  updateDocument(key,datas) {
    return this.http.post(`${this.apiUrl}user/updateDocument/` + key, {datas} ) as any;
  }

  updateValidity(key,datas) {
    return this.http.post(`${this.apiUrl}user/updateValidity/` + key, {datas} ) as any;
  }

}
